var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.75C14.3096 7.75 13.75 8.30964 13.75 9V17.3333C13.75 18.0237 14.3096 18.5833 15 18.5833C15.6904 18.5833 16.25 18.0237 16.25 17.3333V9C16.25 8.30964 15.6904 7.75 15 7.75Z",
    fill: "#EF3838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.75C14.3096 19.75 13.75 20.3096 13.75 21C13.75 21.6904 14.3096 22.25 15 22.25C15.6904 22.25 16.25 21.6904 16.25 21C16.25 20.3096 15.6904 19.75 15 19.75Z",
    fill: "#EF3838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0.75C7.13595 0.75 0.75 7.09453 0.75 14.9343C0.75 22.7522 7.07259 29.25 14.9583 29.25C18.8418 29.25 22.692 29.212 26.5704 29.1737L27.9705 29.1599C28.3763 29.156 28.755 28.9553 28.986 28.6216C29.2171 28.2879 29.2717 27.8628 29.1326 27.4815L27.2188 22.2367C28.5082 20.1031 29.25 17.6034 29.25 14.9343C29.25 7.09453 22.864 0.75 15 0.75ZM3.25 14.9343C3.25 8.48717 8.5047 3.25 15 3.25C21.4953 3.25 26.75 8.48717 26.75 14.9343C26.75 17.3236 26.0302 19.5422 24.794 21.392C24.5726 21.7234 24.5224 22.1405 24.6591 22.515L26.178 26.6775C22.4232 26.7145 18.706 26.75 14.9583 26.75C8.48455 26.75 3.25 21.403 3.25 14.9343Z",
    fill: "#EF3838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessage);
export default __webpack_public_path__ + "static/media/error-message.bbaf5398103c0c6e87261040d42c8ccb.svg";
export { ForwardRef as ReactComponent };